import React from 'react'
import { ArrowRight } from 'lucide-react'

interface DemoCard {
  id: string
  sourceLanguage: string
  targetLanguage: string
  gradient: string
  sourceIcon: string
  targetIcon: string
}

const demos: DemoCard[] = [
  {
    id: 'rust',
    sourceLanguage: 'C',
    targetLanguage: 'Rust',
    gradient: 'from-orange-600 to-red-700',
    sourceIcon: '/logos/c.svg',
    targetIcon: '/logos/rust.svg'
  },
  {
    id: 'javascript',
    sourceLanguage: 'Python',
    targetLanguage: 'JavaScript',
    gradient: 'from-blue-600 to-yellow-600',
    sourceIcon: '/logos/python.svg',
    targetIcon: '/logos/javascript.svg'
  }
]

const MobileDemoList: React.FC = () => {
  const handleCardClick = (demoId: string) => {
    // Navigate to demo viewer with demo ID
    window.location.href = `?page=demo&demo=${demoId}`
  }

  return (
    <div className="space-y-4 max-w-md mx-auto">
      {demos.map((demo) => (
        <button
          key={demo.id}
          onClick={() => handleCardClick(demo.id)}
          className={`
            w-full min-h-[140px] rounded-2xl p-8
            bg-gradient-to-br ${demo.gradient}
            shadow-lg hover:shadow-xl
            active:scale-[0.98]
            transition-all duration-200
            flex flex-col items-center justify-center gap-3
            text-white
          `}
          aria-label={`View ${demo.sourceLanguage} to ${demo.targetLanguage} demo`}
        >
          {/* Language tuple with inline icons */}
          <div className="flex items-center gap-4">
            {/* Source Language */}
            <div className="flex items-center gap-2">
              <img
                src={demo.sourceIcon}
                alt=""
                className="w-6 h-6"
              />
              <span className="text-xl font-bold tracking-wide">
                {demo.sourceLanguage}
              </span>
            </div>

            {/* Arrow */}
            <ArrowRight className="w-5 h-5" strokeWidth={2.5} />

            {/* Target Language */}
            <div className="flex items-center gap-2">
              <img
                src={demo.targetIcon}
                alt=""
                className="w-6 h-6"
              />
              <span className="text-xl font-bold tracking-wide">
                {demo.targetLanguage}
              </span>
            </div>
          </div>

          {/* Subtle hint */}
          <div className="text-white/90 text-sm font-medium">
            Tap to see insights
          </div>
        </button>
      ))}
    </div>
  )
}

export default MobileDemoList
